import { OrgDetailsResponse } from '@api/api.types'
import {
  orgDetailsQueryOptions,
  orgSettingsQueryOptions,
  whiteLabelDetailsQueryOptions,
} from '@src/queryOptions/org'
import { useStoreState } from '@store/index'
import { useQuery } from '@tanstack/react-query'

export const useOrgSettings = () => {
  const { data: orgDetails } = useOrgDetails()
  const location_id = orgDetails?.data.default_location_id
  return useQuery(orgSettingsQueryOptions(location_id))
}

export const useOrgDetails = <TData = OrgDetailsResponse>(
  select?: (data: OrgDetailsResponse) => TData
) => {
  const orgId = useStoreState(state => state.onboarding.orgId)
  return useQuery(orgDetailsQueryOptions({ organizationId: orgId, select }))
}

export const useWhiteLabelAppDetails = () => {
  return useQuery(whiteLabelDetailsQueryOptions)
}
